import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Accordion, Container, Icon, List, Table } from 'semantic-ui-react';
import { ITrain } from '@relab/alstom-ptw-shared';

import { appState } from '../../redux/selectors';
import { TrainCreateComponent } from './TrainCreateComponent';
import { TrainDeleteModal } from './TrainDeleteModal';
import { RootState } from '../../redux/types';
import { TranslationComponent } from '../TranslationComponent';

interface IndipendentAccordionProps {
  title: string;
}

class IndipendentAccordion extends Component<IndipendentAccordionProps> {
  state = {
    isOpen: false,
  };

  onClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { title, children } = this.props;
    const { isOpen } = this.state;

    return (
      <Accordion>
        <Accordion.Title active={isOpen} onClick={this.onClick}>
          <Icon name="dropdown" />
          {title}
        </Accordion.Title>
        <Accordion.Content active={isOpen}>{children}</Accordion.Content>
      </Accordion>
    );
  }
}

interface PTrainsComponentProps {
  trains: ITrain[];
}

const PTrainsComponent = ({ trains }: PTrainsComponentProps) => {
  return (
    <Container>
      <TrainCreateComponent />
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <TranslationComponent stringKey={'Name'} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <TranslationComponent stringKey={'N° Vehicles'} />
            </Table.HeaderCell>
            <Table.HeaderCell />
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {trains.map((train) => (
            <Table.Row key={train._id}>
              <Table.Cell>
                <IndipendentAccordion title={train.name}>
                  <List>
                    {train.vehicles.map((vheicle) => (
                      <List.Item key={vheicle._id}>{vheicle.name}</List.Item>
                    ))}
                  </List>
                </IndipendentAccordion>
              </Table.Cell>
              <Table.Cell verticalAlign="top">{train.vehicles.length}</Table.Cell>
              <Table.Cell>
                <TrainDeleteModal train={train} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

const mapStateToProps = (state: RootState) => ({
  trains: appState(state).project.trains,
});

export const TrainsComponent = connect(mapStateToProps)(PTrainsComponent);
